import type { ComponentType, LazyExoticComponent } from 'react';

/** What a picked cluster is called; same shape as the instance picker's hint, so the grant flow takes both. */
interface ClusterHint {
  name: string;
  serviceId: string;
}

interface ClusterScopePickerProps {
  /** Ids of the clusters the grant will cover. */
  selected: string[];
  onChange: (ids: string[], hints: Record<string, ClusterHint>) => void;
}

interface ProjectClustersProps {
  projectId: string;
}

type Slot<P> = LazyExoticComponent<ComponentType<P>>;

/**
 * Kubernetes parts the Organizations console shows (the cluster list on a project, the cluster picker
 * in a grant). A module may not import another module, so the composition root fills this object
 * (`src/app/register-kubernetes.ts`) and Organizations reads it, like `catalogLandings`. The slots are
 * `lazy` components over a dynamic import, so the Kubernetes console stays out of the entry chunk. The
 * reader renders each inside a `Suspense` and renders nothing when a slot is unfilled (a host without
 * Kubernetes).
 */
export const k8sSlots: {
  ProjectClusters?: Slot<ProjectClustersProps>;
  ClusterScopePicker?: Slot<ClusterScopePickerProps>;
  /** Where a cluster opens (the Kubernetes v2 cluster page); unset on a host without Kubernetes. */
  clusterPath?: (clusterId: string) => string;
} = {};
